/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formname_Placeholder1Inputs */

const ja_contact_formname_placeholder1 = /** @type {(inputs: Contact_Formname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鈴木 太郎`)
};

const en_contact_formname_placeholder1 = /** @type {(inputs: Contact_Formname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eg. Taro Suzuki`)
};

/**
* | output |
* | --- |
* | "eg. Taro Suzuki" |
*
* @param {Contact_Formname_Placeholder1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formname_placeholder1 = /** @type {((inputs?: Contact_Formname_Placeholder1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formname_Placeholder1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formname_placeholder1(inputs)
	return en_contact_formname_placeholder1(inputs)
});
export { contact_formname_placeholder1 as "contact_formName_placeholder" }